

export const contractTypes = [
	{value:1,title:"班组结算单"},
	{value:2,title:"个人结算单"},
	{value:3,title:"工资预支单"},
	{value:4,title:"扫码登记"},
	{value:5,title:"电子合同"},
	{value:6,title:"报销单"},
	{value:7,title:"材料预支单"},
	{value:8,title:"材料领取单"},
	{value:9,title:"材料转运单"},
	{value:10,title:"工资明细单"},
]

